// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ea679c95","703":"47218e46"}[chunkId] + ".chunk.js";
};